import { useEffect,useState } from "react"
import { getInfoTextService } from "../../../../services/infoTextService"
//import { datosConfig } from "../../../helpers/data"
import Coberturas from "../components/Coberturas"
import Contacto from "../components/Contacto"
import FormatosGuias from "../components/FormatosGuias"
import HeadHomeOut from "../components/HeadHomeOut"
import PreguntasFrecuentes from "../components/PreguntasFrecuentes"
//import Seguro from "../components/Seguro"
import Siniestro from "../components/Siniestro"
import { Ecosistema } from "../components/Ecosistema"
import { ActivarCuenta } from "../components/ActivarCuenta"
import SidebarButton from "../../../../components/sidebar/SidebarButton"
import ModalNewPasswordSuccess from "../components/modal/ModalNewPasswordSuccess"
import SidebarLogin from "../../../../components/sidebar/SidebarLogin"

const HomeOutScreen = () => {

    const [coberturas, setCoberturas] = useState();
    const [coberturasDesc, setCoberturasDesc] = useState();
    const [ecosistemas, setEcosistemas] = useState();
    const [siniestros, setSiniestros] = useState();
    const [pasosSiniestros, setPasosSiniestros] = useState();
    const [preguntas, setPreguntas] = useState();
    const [infoApi, setInfoApi] = useState();

    const [showModalSuccess, setShowModalSuccess] = useState(false)
    const [showLogin, setShowLogin] = useState(false)
    
    useEffect(() => {
        try {
            getInfoTextService().then((resp) => {
               

                setCoberturas(resp.CoberturaCards);
                setCoberturasDesc(resp.CoberturaDesc);
                setEcosistemas(resp.EcosistemaCards);
                setSiniestros(resp.TabsSiniestro);
                setPasosSiniestros(resp.PasosSiniestro);
                setPreguntas(resp.PreguntasFrecuentes);
                setInfoApi(resp.InfoApi);
            })

        } catch(error) {
            console.log(error)
        }
        
    },[]);
    return (
        <>
            {/* <div>
                <main> */}

                    <ModalNewPasswordSuccess
                        infoApi={infoApi}
                        show={showModalSuccess}
                        setShow={setShowModalSuccess}
                    />

                    <SidebarLogin
                        infoApi={infoApi}
                        show={showLogin}
                        setShow={setShowLogin}
                        setShowModalSuccess={setShowModalSuccess}
                    />

                    <SidebarButton infoApi={infoApi} setShowModalSuccess={setShowModalSuccess} />
                    <HeadHomeOut />
                    <Coberturas coberturas={coberturas} coberturasDesc={coberturasDesc}/>
                    <Ecosistema ecosistemas={ecosistemas}/>
                    <ActivarCuenta infoApi={infoApi} mostrarLogin={showLogin} setMostrarLogin={setShowLogin} />
                    <Siniestro siniestros={siniestros} pasosSiniestros={pasosSiniestros} />
                    <FormatosGuias />
                    <PreguntasFrecuentes preguntas={preguntas} />
                    <Contacto />
                {/* </main>
            </div> */}
        </>
    )
}

export default HomeOutScreen